import { PopupDto, PopupDtoLocationEnum, PopupDtoSizeEnum } from '@coretava/api/core-service';
import {
  PopupLocationConfigOptions,
  PopupSizeConfigOptions,
  PopupsPositionConfig,
  PopupsSizeConfig,
} from '@gamiphy/bl/popups';
import {
  LARGE_POPUP_SIZE_CONFIG,
  MEDIUM_POPUP_SIZE_CONFIG,
  SMALL_POPUP_SIZE_CONFIG,
} from '@gamiphy/bl/popups/constants';

export const getPopupSizes = (popup?: PopupDto, options?: PopupSizeConfigOptions): PopupsSizeConfig => {
  if (options?.isMiniPreview) {
    return {
      ...SMALL_POPUP_SIZE_CONFIG,
      width: '100%',
    };
  }
  if (options?.isMobile) {
    return {
      ...SMALL_POPUP_SIZE_CONFIG,
      width: '90%',
      padding: '1.6rem',
    };
  }
  switch (popup?.size) {
    case PopupDtoSizeEnum.Large:
      return LARGE_POPUP_SIZE_CONFIG;
    case PopupDtoSizeEnum.Small:
      return SMALL_POPUP_SIZE_CONFIG;
    case PopupDtoSizeEnum.Medium:
    default:
      return MEDIUM_POPUP_SIZE_CONFIG;
  }
};

export const getPopupPosition = (popup?: PopupDto, options?: PopupLocationConfigOptions): PopupsPositionConfig => {
  const position = (() => {
    switch (popup?.location) {
      case PopupDtoLocationEnum.Left:
        return {
          top: 'unset',
          right: 'unset',
          bottom: 'unset',
          left: 16,
        };
      case PopupDtoLocationEnum.TopLeft:
        return {
          top: 16,
          right: 'unset',
          bottom: 'unset',
          left: 16,
        };
      case PopupDtoLocationEnum.Top:
        return {
          top: 16,
          right: 'unset',
          bottom: 'unset',
          left: 'unset',
        };
      case PopupDtoLocationEnum.TopRight:
        return {
          top: 16,
          right: 16,
          bottom: 'unset',
          left: 'unset',
        };
      case PopupDtoLocationEnum.Right:
        return {
          top: 'unset',
          right: 16,
          bottom: 'unset',
          left: 'unset',
        };
      case PopupDtoLocationEnum.BottomRight:
        return {
          top: 'unset',
          right: 16,
          bottom: 16,
          left: 'unset',
        };
      case PopupDtoLocationEnum.Bottom:
        return {
          top: 'unset',
          right: 'unset',
          bottom: 16,
          left: 'unset',
        };
      case PopupDtoLocationEnum.BottomLeft:
        return {
          top: 'unset',
          right: 'unset',
          bottom: 16,
          left: 16,
        };
      default:
        return {
          top: 'unset',
          right: 'unset',
          bottom: 'unset',
          left: 'unset',
        };
    }
  })();

  if (options?.isMobile) {
    return {
      ...position,
      left: 'unset',
      right: 'unset',
    };
  }
  return position;
};
